import { ArrayHelpers, useFormikContext } from 'formik';
import React, { ReactElement } from 'react';
import { Client, Lieu } from '../../../../../common/src/entities';
import ClientLieu from '../../../../../common/src/entities/client-lieu.entity';
import { useAlertDialog } from '../../../Utils/dialogContext';
import ChampMultiple, { affichageElementDefaut } from '../../Common/ChampMultiple';
import { PopoutEntite } from '../Utils/PopoutEntite';
import CreerLieu from './CreerLieu';
import { cssTexte } from '../constantes';
import { FaDollarSign, FaRegClipboard } from 'react-icons/fa';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CopierPressePapier } from '../Utils/CopierPressePapier';
import { afficherLieu } from './utils';

type Class<T = unknown> = new (...args: unknown[]) => T;

interface PropsAffichageAjout {
    helpers: ArrayHelpers;
    values: ClientLieu[];
    avecUnBouton?: boolean;
    title?: string;
    maxSize?: number;
}

function AffichageAjout(props: PropsAffichageAjout): ReactElement {
    const bsAlert = useAlertDialog();
    const { values: client } = useFormikContext<Client>();
    return (
        <PopoutEntite
            titre={`Ajouter un ${props.title?.toLowerCase() ?? 'lieu'}`}
            entite={Lieu}
            isCreatable
            modalSize="lg"
            modalBody={(props) => <CreerLieu {...props} />}
            size="sm"
            onChange={(value) => {
                const lieu = value as Lieu;
                if (lieu) {
                    if (props.values.find((item) => item.lieu.id === lieu.id)) {
                        bsAlert('Ce lieu est déja associé!', 'warning');
                    } else {
                        //les fk sont requis pour l'enregistrement dans la bd
                        props.helpers.push({ lieu, fk_id_client: client.id, fk_id_lieu: lieu.id });
                    }
                } else {
                    alert();
                }
            }}
            avecUnBouton={props.avecUnBouton}
        />
    );
}

function AffichageTexte(props: { value: ClientLieu }): ReactElement {
    const {
        value: { lieu },
    } = props;

    const lieuTexte = afficherLieu(lieu);

    return (
        <div
            style={{
                fontSize: '0.875rem',
            }}
        >
            <span>
                {lieuTexte}
                <CopierPressePapier texte={lieuTexte}>
                    <OverlayTrigger
                        overlay={<Tooltip id={'tooltip-lieu-cpy'}>Copier vers le presse-papier</Tooltip>}
                        placement="top"
                    >
                        <FaRegClipboard />
                    </OverlayTrigger>
                </CopierPressePapier>
                <OverlayTrigger
                    overlay={<Tooltip id={'tooltip-lieu-facturation'}>Adresse de facturation</Tooltip>}
                    placement="top"
                >
                    <FaDollarSign />
                </OverlayTrigger>
            </span>
        </div>
    );
}

interface PropsAffichageDetail {
    value: ClientLieu;
}

function AffichageDetail(props: PropsAffichageDetail): ReactElement {
    return <div style={cssTexte}>{props.value.detail}</div>;
}

const affichageTexte = (value) => <AffichageTexte value={value} />;

export interface PropsChampMultipleClientLieu {
    id: string;
    labelCol?: number;
    avecUnBouton?: boolean;
    details: (index: number) => string;
    suggestions: string[];
    maxSize?: number;
    title?: string;
    placeholder?: string;
    clickCrayon?: (index: number) => void;
}

export default function ChampMultipleClientLieu(props: PropsChampMultipleClientLieu): ReactElement {
    const affichageAjout = (values, helpers) => (
        <AffichageAjout helpers={helpers} values={values} avecUnBouton={props.avecUnBouton} />
    );
    return (
        <ChampMultiple
            entite={ClientLieu}
            titre={`${props.title ?? 'Lieux'}`}
            {...props}
            affichageAjout={affichageAjout}
            affichageElement={(value: ClientLieu | number, index: number, helpers: ArrayHelpers) => {
                return affichageElementDefaut(Lieu)((value as ClientLieu).lieu, index, helpers, () =>
                    affichageTexte(value),
                );
            }}
            clickCrayon={props.clickCrayon}
            AffichageDetail={(value) => <AffichageDetail value={value} />}
        />
    );
}
